import { lazy } from "react";
import { Lazy } from "../Lazy/Lazy";

const PromotionsPage = lazy(() => import("./PromotionsPage"));

/**
 * Route shell for /promotions. The page draws the booking pages' own header
 * (SF 05: back, the title, translate), so there is no site menu to feed: it
 * reads the location and who is signed in itself, and sign-in is App's gate.
 */
export default function PromotionsWrapper() {
  return (
    <Lazy>
      <PromotionsPage />
    </Lazy>
  );
}
